const POLL_INTERVAL_MS = 100;

/**
 * Resolves the LFX analytics instance once its CDN script has run, or `null` if it has not run
 * within `timeoutMs` (blocked, failed to load, or not configured).
 *
 * The script tag is `async` and the CDN revalidates it on every page load, so on repeat visits
 * Angular usually renders before `window.LfxAnalytics` exists. Checking once at render time
 * silently skips the analytics call; wait for it instead.
 */
export async function whenLfxAnalyticsReady(timeoutMs = 10000): Promise<LfxSegmentsAnalyticsInstance | null> {
  const deadline = Date.now() + timeoutMs;
  while (!(window.LfxAnalytics && window.LfxAnalytics.LfxSegmentsAnalytics)) {
    if (Date.now() >= deadline) {
      return null;
    }
    await new Promise((resolve) => setTimeout(resolve, POLL_INTERVAL_MS));
  }
  const analytics = window.LfxAnalytics.LfxSegmentsAnalytics.getInstance();
  // The script tag's onload has normally started it already; init() reuses that run.
  await analytics.init();
  return analytics;
}
